module.exports = __webpack_public_path__ + "img/base.fa2319af.png";